export const all_routes = {
  /* ===========================
      HOME / MAIN
  ============================ */
  home: "/index",
  home2: "/index-2",
  home3: "/index-3",
  home4: "/index-4",
  home5: "/index-5",
  home6: "/index-6",
  home7: "/index-7",
  home8: "/index-8",
  home9: "/index-9",
  home10: "/index-10",
  home11: "/index-11",
  home12: "/index-12",
  home13: "/index-13",
  home14: "/index-14",
  home15: "/index-15",
  home16: "/index-16",
  home17: "/index-17",
  home18: "/index-18",

  /* ===========================
      DOCTORS
  ============================ */
  doctorDashboard: "/doctor-dashboard",
  doctorAppointments: "/appointments",
  doctorAppointmentsGrid:"/doctor-appointments-grid",
  doctorAppointmentsStart: "/doctor-appointment-start",
  doctorCancelledAppointment: "/doctor-cancelled-appointment",
  doctorcCompletedAppointment: "/doctor-completed-appointment",
  doctorCancelledAppointment2: "/doctor-cancelled-appointment-2",
  doctorAvailableTimings: "/available-timings",
  doctorUpcomingAppointment: "/doctor-upcoming-appointment",
  doctorAppointmentDetails: "/doctor-appointment-details",
  doctorMypatients: "/my-patients",
  patientDetails: "/patient-details",
  doctorChat: "/chat-doctor",
  doctorInvoices: "/invoices",
  doctorProfileSettings: "/doctor-profile-settings",
  doctorRequest:"/doctor-request",
  doctorSpecialities: "/doctor-specialities",
  doctorAccounts: "/accounts",
  doctorPayment: "/doctor-payment",
  doctorBlog: "/doctor-blog",
  doctorPendingBlog: "/doctor-pending-blog",
  doctorExperienceSettings: "/doctor-experience-settings",
  doctorEducationSettings: "/doctor-education-settings",
  doctorAwardsSettings: "/doctor-awards-settings",
  doctorInsuranceSettings: "/doctor-insurance-settings",
  doctorClinicsSettings: "/doctor-clinics-settings",
  doctorBusinessSettings: "/doctor-business-settings",
  doctorAddBlog: "/doctor-add-blog",
  doctorSocialMedia: "/social-media",
  doctorChangePassword: "/doctor-change-password",
  doctorRegister: "/doctor-register",


  /* ===========================
      PATIENTS
  ============================ */
  patientDashboard: "/patient-dashboard",
  patientProfile: "/patient-profile",
  doctorsGrid: "/doctor-grid",
  doctorsList: "/doctor-list",
  doctorsAvailability: "/map-list-availability",
  booking: "/booking",
  booking1: "/booking-1",
  booking2: "/booking-2",
  bookingPopup: "/booking-popup",
  search1: "/search-doctor1",
  search2: "/search-doctor2",
  doctorProfile1: "/doctor-profile",
  doctorProfile2: "/doctor-profile-2",
  checkout: "/checkout",
  favourites: "/favourites",
  chat: "/chat",
  patientProfileSettings: "/profile-settings",
  patientChangePassword: "/change-password",
  patientTwoFactor: "/two-factor-authentication",
  patientDeleteAccount: "/delete-account",
  patientAppointments: "/patient-appointments",
  patientAppointmentsGrid: "/patient-appointments-grid",
  patientUpcomingAppointments: "/patient-upcoming-appointments",
  patientCancelAppointments: "/patient-cancel-appointments",
  patientCompletedAppointments: "/patient-completed-appointments",
  patientAppointmentsDetails: "/patient-appointment-details",
  patientDependants: "/dependent",
  patientMedicalRecords: "/medical-records",
  patientAccounts: "/patient-accounts",
  patientInvoices: "/patient-invoices",
  patientMedicalDetails: "/medical-details",
  paitentDetails: "/paitent-details",
  mapGrid: "/map-grid",
  mapList: "/map-list",
  doctorListAvailability: "/map-list-availability",
  patientChat: "/chat",

  /* ===========================
      PHARMACY
  ============================ */
  pharmacyIndex: "/pharmacy-index",
  pharmacyDetails: "/pharmacy-details",
  pharmacySearch: "/pharmacy-search",
  productAll: "/product-all",
  productDescription: "/product-description",
  cart: "/cart",
  productCheckout: "/product-checkout",
  paymentSuccess: "/payment-success",
  pharmacyRegister: "/pharmacy-register",

  /* ===========================
      PAGES
  ============================ */
  aboutUs: "/about-us",
  contactUs: "/contact-us",
  hospitals: "/hospitals",
  speciality: "/speciality",
  clinics: "/clinic",
  starterPage: "/blank-page",
  pricing: "/pricing",
  reviews: "/reviews",
  appointments: "/appointments",
  faq: "/faq",
  login: "/login",
  signup: "/signup",
  register: "/register",
  loginEmail: "/login-email",
  loginPhone: "/login-phone",
  doctorSignup: "/doctor-signup",
  patientSignup: "/patient-signup",
  forgotPassword1: "/forgot-password",
  forgotPassword2: "/forgot-password2",
  loginEmailOtp: "/login-email-otp",
  loginPhoneOtp: "/login-phone-otp",
  maintenance: "/maintenance",
  comingSoon: "/coming-soon",
  termsAndCondition: "/terms-condition",
  privacyPolicy: "/privacy-policy",
  components: "/components",
  invoiceList: "/invoices",
  invoiceView: "/invoice-view",
  voiceCall: "/voice-call",
  videoCall: "/video-call",
  error404: "/error-404",
  error500: "/error-500",

  /* ===========================
      BLOG
  ============================ */
  blogList: "/blog-list",
  blogGrid: "/blog-grid",
  blogDetails: "/blog-details",
  editBlog: "/edit-blog",

  /* ===========================
      EXTERNAL / ADMIN
  ============================ */
  admin: "/admin/index",
  pharmacyAdmin: "/pharmacy/index",
};
